module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm1_en.0f482777e9abb478d7c868c5214e5a7e.png";